package one.healthium.pilates.ui.workouts

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.onStart
import one.healthium.base.preferences.AppPreferences
import one.healthium.healthKit.data.HealthKitHelper
import one.healthium.healthKit.ui.HealthKitConnectBannerContract
import one.healthium.insights.domain.workouts.WorkoutsRepository
import one.healthium.meal_plans.domain.MealPlanRepository
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

class WorkoutsViewModel(
    workoutsRepository: WorkoutsRepository,
    appPreferences: AppPreferences,
    mealPlanRepository: MealPlanRepository,
    private val healthKitHelper: HealthKitHelper,
) : BaseViewModel(), HealthKitConnectBannerContract {

    private val _state = MutableStateFlow(WorkoutsUiState())
    val state = _state.asStateFlow()

    val uiMessages = UiMessageManager()

    init {
        combine(
            workoutsRepository.getScreen(),
            mealPlanRepository.getCurrentMealPlan().catch { emit(null) },
            appPreferences.isMetricFlow,
        ) { workouts, mealPlan, isMetrics ->
            _state.value = _state.value.copy(
                content = workouts,
                mealPlan = mealPlan,
                loading = false,
                isMetrics = isMetrics,
            )
        }
            .onStart { _state.value = _state.value.copy(loading = true) }
            .catch {
                _state.value = _state.value.copy(loading = false)
                Logger.e(it) { "Error loading workouts" }
            }
            .launch()

        healthKitHelper.healthKitStatus
            .onEach { _state.value = _state.value.copy(shouldShowHKBanner = appPreferences.didReactToHKBanner == null) }
            .catch { _state.value = _state.value.copy(shouldShowHKBanner = false) }
            .launch()
    }

    override fun onSkipClicked() {
        healthKitHelper.processSkipRequest()
    }
}